// src/i18n/translations/de.js

export default {
  // Allgemeine Elemente und Aktionen
  common: {
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    loading: 'Lädt',
    success: 'Erfolg',
    error: 'Fehler',
    confirm: 'Bestätigen',
    warning: 'Warnung',
    info: 'Info',
    close: 'Schließen',
    cancel: 'Abbrechen',
    changeLanguage: 'Sprache ändern',
    changingLanguage: 'Sprache wird geändert...',
    languageInfoDescription: 'Sprachänderungen werden sofort angewendet und in allen Inhalten angezeigt. Ihre Präferenz wird automatisch gespeichert.',
    quickAccess: 'Schnellzugriff',
    closeMenu: 'Menü schließen',
    tools: 'Werkzeuge',
    me: 'Ich',
    add: 'Hinzufügen',
    copy: 'Kopieren',
    copyLink: 'Link kopieren',
    share: 'Teilen',
    copyFailed: 'Kopieren fehlgeschlagen:',
    name: 'Name',
    user: 'Benutzer',
    continue: 'Fortfahren',
    processing: 'Wird verarbeitet...',
    change: 'Ändern',
    copied: 'Kopiert',
    understand: 'Ich verstehe',
    ok: 'OK',
    back: 'Zurück',
    backToDashboard: 'Zurück zum Dashboard',
    digitalDiscipline: 'Digitale Disziplin'
  },

  // Slogans
  slogan: {
    decentralized: "Die weltweit erste dezentralisierte Identitätslösung",
    evolution: "Der nächste Schritt in der Identitätsevolution",
    control: "Übernehmen Sie die Kontrolle über Ihre Daten",
    secure: "Die sichere Festung Ihrer digitalen Identität"
  },

  // Einstellungen
  settings: {
    title: 'Einstellungen'
  },

  // Navigation und Menüelemente
  nav: {
    dashboard: 'Dashboard',
    profile: 'Profil',
    digitalVault: 'Digitaler Tresor',
    settings: 'Einstellungen',
    twoFA: 'Zwei-Faktor-Authentifizierung',
    qrCode: 'QR-Code',
    logout: 'Abmelden',
    gameHub: 'Spielezentrum',
    messages: 'Nachrichten',
    qr: 'QR-Code',
    notifications: 'Benachrichtigungen',
    vault: 'Digitaler Tresor'
  },

  // Willkommensbildschirm
  welcome: {
    title: 'Erste dezentralisierte Identität der Welt',
    subtitle: 'Tritt IDapps bei und betrete die neue Welt',
    loginButton: 'Anmelden',
    signupButton: 'Konto erstellen',
    footer: {
      description: 'Dezentralisierte Blockchain-gestützte Identitätsplattform',
      version: 'v1.0.1 © 2023-2025 IDapps'
    },
    welcomeTitle: 'Willkommen',
    heroTitle: 'Ihre Identität,\nNeu gedacht.',
    getStarted: 'Loslegen',
    haveAccount: 'Haben Sie bereits ein Konto?',
    login: 'Anmelden',
    signInWithApple: 'Mit Apple anmelden'
  },

  // Anmeldebildschirm und Authentifizierung
  login: {
    title: 'Erste dezentralisierte Identität der Welt',
    subtitle: 'Melden Sie sich an, um auf Ihren digitalen Tresor zuzugreifen',
    usernameInput: 'Benutzername oder E-Mail',
    formError: {
      emptyFields: 'Bitte geben Sie Benutzernamen und Passwort ein.',
      default: 'Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihren Benutzernamen und Ihr Passwort.',
      demoFailed: 'Demo-Anmeldung fehlgeschlagen.'
    },
    loggingIn: 'Anmeldung läuft...',
    loginButton: 'Anmelden',
    demoLoginDone: 'Demo-Anmeldung abgeschlossen',
    demoLogin: 'Demo-Anmeldung (Entwickler)',
    forgotPassword: 'Passwort vergessen',
    noAccount: 'Noch kein IDapps-Konto?',
    createAccount: 'Konto erstellen',
    loginTitle: 'Anmelden',
    welcomeBack: 'Willkommen zurück',
    username: 'Benutzername',
    email: 'E-Mail',
    password: 'Passwort',
    forgot: 'Passwort vergessen?',
    submit: 'Anmelden',
    processing: 'Verarbeitung...',
    create: 'Identität erstellen',
    error: {
      empty: 'Bitte füllen Sie alle Felder aus',
      failed: 'Anmeldung fehlgeschlagen. Überprüfen Sie Ihre Anmeldedaten.'
    }
  },

  // Registrierungsbildschirm
  signup: {
    title: 'Erste dezentralisierte Identität der Welt',
    subtitle: 'Tritt IDapps bei und betrete die neue Welt',
    createIdappsAccount: 'IDapps-Konto erstellen',
    createAccountWithApple: 'MIT APPLE KONTO ERSTELLEN',
    createAccountWithFacebook: 'MIT FACEBOOK KONTO ERSTELLEN',
    alreadyHaveAccount: 'Haben Sie bereits ein IDapps-Konto?',
    signupTitle: 'Registrieren',
    confirmPassword: 'Passwort bestätigen',
    phoneNumber: 'Telefonnummer',
    verificationCode: 'Bestätigungscode',
    continueButton: 'Fortfahren',

    // New Signup Flow Keys
    nameTitle: "Wie heißen Sie?",
    nameSubtitle: "Dies wird in Ihrem Profil angezeigt",
    namePlaceholder: "Ihr vollständiger Name",

    emailTitle: "Wie lautet Ihre E-Mail?",
    emailSubtitle: "Diese wird zur Kontoverifizierung verwendet",
    emailPlaceholder: "name@beispiel.de",

    passwordTitle: "Erstellen Sie ein Passwort",
    passwordSubtitle: "Machen Sie es stark und einzigartig",
    passwordPlaceholder: "Mindestens 8 Zeichen",

    confirmTitle: "Details bestätigen",
    confirmSubtitle: "Stellen Sie sicher, dass alles korrekt ist",

    complete: "Konto erstellen",
    haveAccount: "Haben Sie bereits ein Konto?",
    login: "Anmelden",

    error: {
      nameRequired: "Name ist erforderlich",
      emailRequired: "E-Mail ist erforderlich",
      emailInvalid: "Ungültige E-Mail-Adresse",
      passwordLength: "Passwort muss mindestens 8 Zeichen lang sein",
      generic: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      empty: 'Bitte füllen Sie alle Felder aus'
    }
  },

  // Profilbereich
  profile: {
    personalInfo: 'Persönliche Informationen',
    bloodType: 'Blutgruppe',
    height: 'Größe',
    weight: 'Gewicht',
    heightWeight: 'Größe / Gewicht',
    languages: 'Sprachen',
    contacts: 'Kontakte',
    bio: 'Über mich',
    editProfile: 'Profil bearbeiten',
    identity: 'Identität',
    profileTitle: 'Profil',
    qrId: 'Meine QR-ID',
    tattoo: 'Tattoo',
    shareProfileQR: 'Zeigen Sie diesen QR-Code, um Ihr Profil zu teilen',
    profileLinkCopied: 'Profil-Freigabelink kopiert',
    shareProfileDescription: 'Sie können diesen QR-Code verwenden, um das Profil von {name} zu teilen'
  },

  // Sicherheit und Authentifizierung
  security: {
    security: 'Sicherheit',
    securityStatus: 'Sicherheitsstatus',
    accountSecure: 'Ihr Konto ist sicher',
    securityMeasuresActive: 'Alle Sicherheitsmaßnahmen sind aktiv.',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    active: 'Aktiv',
    passwordStrength: 'Passwortstärke',
    strong: 'Stark',
    lastLogin: 'Letzte Anmeldung',
    today: 'Heute',
    manageSecuritySettings: 'Sicherheitseinstellungen verwalten',
    blockchainSecurity: 'Blockchain-Sicherheit',
    blockchainSecurityDesc: 'Ihr Konto ist durch die Blockchain-Wallet-Verbindung mit zusätzlicher Sicherheit geschützt.',
    connectedWallet: 'Verbundene Wallet',
    securityVerification: 'Sicherheitsverifizierung',
    biometricAuth: 'Biometrische Authentifizierung',
    setupTwoFA: '2FA-Einrichtung',
    scanQRCode: 'QR-Code scannen',
    enterCode: 'Code eingeben',
    recoveryKey: 'Wiederherstellungsschlüssel',
    backupCodes: 'Backup-Codes',
    passwordAndSecurity: 'Passwort und Sicherheit',
    emailAndContact: 'E-Mail und Kontakt',
    twoFactorAuthTitle: 'Zwei-Faktor-Authentifizierung',
    securitySettings: 'Sicherheitseinstellungen',
    endToEndEncryption: 'Ende-zu-Ende-Verschlüsselung',
    enhancedSecurityMode: 'Erweiterter Sicherheitsmodus aktiv',
    maxSecurityMode: 'Maximaler Sicherheitsmodus aktiv',
    endToEndEncryptionAccess: 'Ende-zu-Ende-verschlüsselter sicherer Zugriff',
    secure: 'Sicher',
    customQR: 'Benutzerdefinierter QR',
    customQRCodes: 'Benutzerdefinierte QR-Codes',
    customQRDescription: 'Erstellen Sie benutzerdefinierte QR-Codes für Ihre häufig verwendeten Links und teilen Sie sie schnell.',
    noCustomQR: 'Sie haben noch keine benutzerdefinierten QR-Codes.',
    linkName: 'Link-Name',
    addNewQRCode: 'Neuen QR-Code hinzufügen',

    // Zwei-Faktor-Authentifizierungsbereich
    twoFA: {
      // Tabs
      tabs: {
        setup: 'Einrichtung',
        codes: 'Codes',
        backup: 'Backup',
        devices: 'Geräte'
      },

      // Statusmeldungen
      status: {
        enabled: '2FA aktiviert',
        disabled: '2FA nicht aktiviert'
      },

      // Fehlermeldungen
      errors: {
        walletRequired: 'Sie müssen zuerst Ihre Blockchain-Wallet verbinden, um 2FA einzurichten.',
        setupFailed: 'Bei der Einrichtung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
        invalidCode: 'Bitte geben Sie den 6-stelligen Bestätigungscode ein.',
        verificationFailed: 'Ungültiger Bestätigungscode. Bitte versuchen Sie es erneut.',
        generalError: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
        codeRequired: 'Bitte geben Sie den Sicherheitsbestätigungscode ein.',
        disableFailed: '2FA konnte nicht deaktiviert werden. Der Code könnte falsch sein.',
        passwordTooShort: 'Bitte geben Sie ein Passwort mit mindestens 8 Zeichen ein.',
        exportFailed: '2FA-Daten konnten nicht exportiert werden.',
        noImportData: 'Bitte geben Sie 2FA-Daten zum Importieren ein.',
        passwordRequired: 'Bitte geben Sie Ihr Passwort ein.',
        importFailed: '2FA-Daten konnten nicht importiert werden. Das Passwort könnte falsch sein.',
        deviceRemoveFailed: 'Gerät konnte nicht entfernt werden.'
      },

      // Erfolgsmeldungen
      success: {
        verified: 'Verifizierung erfolgreich! 2FA aktiviert.',
        disabled: '2FA erfolgreich deaktiviert.',
        exported: '2FA-Daten erfolgreich exportiert.',
        imported: '2FA-Daten erfolgreich importiert.',
        deviceRemoved: 'Gerät erfolgreich entfernt.',
        deviceVerified: 'Gerät erfolgreich verifiziert.',
        enabled: '2FA aktiviert!',
        enabledDescription: 'Zwei-Faktor-Authentifizierung wurde erfolgreich aktiviert. Ihr Konto ist jetzt sicherer.'
      },

      // Allgemeine Labels und Beschreibungen
      decentralized: 'Dezentralisierte 2FA',
      description: 'Die Zwei-Faktor-Authentifizierung (2FA) fügt Ihrem Konto eine zusätzliche Sicherheitsebene hinzu. Diese Funktion stellt sicher, dass Ihr Konto geschützt ist, selbst wenn Ihr Passwort kompromittiert wird.',
      scanQRCode: 'QR-Code scannen',
      scanQRDescription: 'Scannen Sie den QR-Code unten mit Google Authenticator, Authy oder einer ähnlichen Authentifizierungs-App.',
      manualKeyInstructions: 'Wenn Sie den QR-Code nicht scannen können, können Sie diesen Schlüssel manuell eingeben:',
      verificationCode: 'Bestätigungscode',
      enterSixDigitCode: '6-stelligen Code eingeben',
      disableInstructions: 'Die Zwei-Faktor-Authentifizierung ist derzeit aktiviert. Um diese Funktion zu deaktivieren, geben Sie einen Bestätigungscode aus Ihrer Authentifizierungs-App ein.',
      currentCode: 'Aktueller Code',
      codeRefreshTime: 'Aktualisiert in {seconds} Sekunden',
      codeRefreshing: 'Aktualisierung...',
      backupCodes: 'Backup-Codes',
      backupCodesInstructions: 'Sie können diese Backup-Codes verwenden, wenn Sie keinen Zugriff auf Ihr 2FA-Gerät haben. Jeder Code kann nur einmal verwendet werden.',
      backupCodesDescription: 'Speichern Sie diese Backup-Codes an einem sicheren Ort. Sie können sie verwenden, wenn Sie keinen Zugriff auf Ihre Authentifizierungs-App haben.',
      saveBackupCodes: 'Backup-Codes speichern',
      blockchainVerification: 'Blockchain-Verifizierung',
      blockchainVerificationDescription: 'Ihre 2FA-Verifizierungsnachweise werden sicher auf der Blockchain gespeichert und verifiziert.',
      lastVerification: 'Letzte Verifizierung',
      timeAgo: 'vor {time} Stunden',
      verifiedOnPolygon: 'Verifiziert auf dem Polygon-Netzwerk',
      proofGenerated: 'Verifizierungsnachweis generiert: {proof}...',
      enableFirstToViewCodes: 'Sie müssen zuerst 2FA aktivieren, um Verifizierungscodes anzuzeigen.',
      backupAndRecovery: 'Backup und Wiederherstellung',
      backupDescription: 'Sie können Ihre 2FA-Daten (verschlüsselt) exportieren oder zuvor gesicherte Daten importieren.',
      exportData: 'Daten exportieren',
      exportDescription: 'Exportieren Sie Ihre 2FA-Daten verschlüsselt mit einem starken Passwort. Speichern Sie diese Datei an einem sicheren Ort.',
      password: 'Passwort',
      passwordPlaceholder: 'Geben Sie Ihr Passwort ein (mindestens 8 Zeichen)',
      encryptedData: 'Verschlüsselte Daten',
      storeDataSafely: 'Speichern Sie diese Daten sicher. Wenn Sie Ihr Passwort vergessen, können Sie die Daten nicht wiederherstellen.',
      importData: 'Daten importieren',
      importDescription: 'Importieren Sie 2FA-Daten, die Sie zuvor exportiert haben. Dies ändert Ihre aktuellen 2FA-Einstellungen.',
      pasteEncryptedData: 'Fügen Sie exportierte verschlüsselte Daten ein',
      enterPassword: 'Geben Sie Ihr Passwort ein',
      arweaveBackup: 'Arweave-Backup',
      arweaveDescription: 'Ihre 2FA-Verifizierungsnachweise werden verschlüsselt auf Arweave gespeichert. Dies bietet ein permanentes und unveränderliches Backup.',
      arweaveBackupStarted: 'Arweave-Backup-Prozess gestartet. Dies kann einige Minuten dauern.',
      decentralizedStorage: 'Dezentralisierter Speicher',
      arweaveTokenRequired: 'Arweave gewährleistet eine permanente und unveränderliche Speicherung Ihrer Daten. Für den Backup-Prozess wird eine kleine Menge AR-Token benötigt.',
      verifiedDevices: 'Verifizierte Geräte',
      devicesDescription: 'Sie können Ihre 2FA-verifizierten Geräte hier verwalten.',
      noVerifiedDevices: 'Noch keine verifizierten Geräte.',
      thisDevice: 'Dieses Gerät',
      deviceVerificationDescription: 'Das Gerät, das Sie verwenden, wird automatisch der Liste der verifizierten Geräte hinzugefügt. Überprüfen Sie regelmäßig Ihre Geräte und entfernen Sie alle Geräte, die Sie nicht erkennen.',
      deviceConnectionHistory: 'Gerätverbindungsverlauf',
      lastAccess: 'Letzter Zugriff: {time}',
      daysAgo: 'vor {days} Tagen',
      weeksAgo: 'vor {weeks} Wochen',

      // Gerätetypen
      deviceTypes: {
        mobile: 'Mobilgerät',
        desktop: 'Desktop-Gerät'
      },

      // Funktionsbereich
      features: {
        highSecurity: {
          title: 'Hohe Sicherheit',
          description: 'Authentifizierungscodes werden mit einem geheimen Schlüssel erstellt, der auf Ihrem Gerät gespeichert ist.'
        },
        easyToUse: {
          title: 'Einfach zu verwenden',
          description: 'Sie können jede Authentifizierungs-App mit QR-Code-Scanning verwenden.'
        },
        decentralized: {
          title: 'Dezentralisiert',
          description: 'Sicherheitsdaten werden auf der Blockchain verifiziert, ohne von Servern abhängig zu sein.'
        }
      },

      // Wiederherstellungsinfo-Modal
      recoveryInfo: {
        title: 'Wiederherstellungsinformationen',
        description: 'Mit 2FA-Wiederherstellungsoptionen können Sie auf Ihr Konto zugreifen, selbst wenn Sie Ihr Gerät verlieren oder Ihre App löschen:',
        backupCodes: {
          title: 'Backup-Codes',
          description: 'Jeder Backup-Code ist für einmalige Verwendung gültig. Bewahren Sie diese Codes an einem sicheren Ort auf.'
        },
        encryptedBackup: {
          title: 'Verschlüsseltes Backup',
          description: 'Sie können Ihre 2FA-Daten in verschlüsselter Form exportieren. Vergessen Sie dieses Passwort nicht, sonst kann das Backup nicht verwendet werden.'
        },
        verifiedDevices: {
          title: 'Verifizierte Geräte',
          description: 'Ihre zuvor verifizierten Geräte können Ihnen beim Authentifizierungsprozess helfen.'
        }
      },

      // Gerät entfernen Modal
      removeDevice: {
        title: 'Gerät entfernen',
        confirmation: 'Sind Sie sicher, dass Sie dieses Gerät entfernen möchten?'
      },

      // Buttons
      buttons: {
        startingSetup: 'Einrichtung starten',
        startSetup: '2FA-Einrichtung starten',
        verifying: 'Überprüfung...',
        verify: 'Verifizieren',
        disable: '2FA deaktivieren',
        copyCode: 'Code kopieren',
        copyAll: 'Alle kopieren',
        generateNewCodes: 'Neue Codes generieren',
        generateProof: 'Verifizierungsnachweis generieren',
        goToSetup: 'Zur 2FA-Einrichtung gehen',
        export: 'Exportieren',
        import: 'Importieren',
        backupToArweave: 'Backup auf Arweave',
        verifyThisDevice: 'Dieses Gerät verifizieren'
      }
    }
  },

  // Digitaler Tresor und Notizen
  vault: {
    vault: 'Tresor',
    notes: 'Notizen',
    backups: 'Backups',
    addNote: 'Notiz hinzufügen',
    searchNotes: 'Notizen durchsuchen',
    noteTitle: 'Notiz-Titel',
    noteContent: 'Notiz-Inhalt',
    addTag: 'Tag hinzufügen',
    saveNote: 'Notiz speichern',
    digitalVaultTitle: 'Digitaler Tresor',
    endlessNotesTitle: 'Endlose Notizen',
    memoryPalace: 'Gedächtnispalast'
  },

  // App-Einstellungen
  settings: {
    appSettings: 'App-Einstellungen',
    appSettingsDesc: 'Verwalten Sie das App-Verhalten und Ihre Präferenzen',
    accountSettings: 'Kontoeinstellungen',
    accountSettingsDesc: 'Verwalten Sie Ihre Profilinformationen und Präferenzen',
    languageSelection: 'Sprachauswahl',
    selectLanguageDescription: 'Wählen Sie die Sprache aus, die Sie für die App verwenden möchten.',
    themeAndAppearance: 'Design und Erscheinungsbild',
    notificationSettings: 'Benachrichtigungseinstellungen',
    languageAndRegion: 'Sprache und Region',
    other: 'Sonstiges',
    helpAndSupport: 'Hilfe und Support',
    aboutAndLegal: 'Über uns und Rechtliches',
    confirmLogout: 'Möchten Sie sich abmelden?',
    logoutDescription: 'Sie sind dabei, sich von Ihrem Konto abzumelden. Sie müssen sich erneut anmelden.'
  },

  // Kontoinformationen
  account: {
    title: 'Kontoinformationen eingeben',
    description: 'Geben Sie Kontoinformationen ein, um den Kontoerstellungsprozess abzuschließen.',
    gender: {
      male: 'Männlich',
      female: 'Weiblich',
      other: 'Anderes'
    },
    error: {
      missingFields: 'Bitte füllen Sie alle erforderlichen Felder aus.',
      passwordMismatch: 'Passwörter stimmen nicht überein.',
      passwordTooShort: 'Passwort muss mindestens 6 Zeichen lang sein.'
    },
    termsAgreement: 'Durch die Erstellung eines Kontos stimmen Sie den {terms} und der {privacy} zu.',
    termsAndConditions: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutzrichtlinie'
  },

  // Dashboard-Bereich
  dashboard: {
    exhibitions: 'Ausstellungen',
    identity: 'Identität',
    myFolders: 'Meine Ordner',
    qrIdentity: 'QR-Identität',
    badges: 'Abzeichen',
    activity: 'Aktivität',
    active: 'Aktiv',
    noItems: 'Noch keine Elemente in diesem Ordner',
    addItem: 'Element hinzufügen',
    folders: {
      personal: 'Persönlich',
      health: 'Gesundheit',
      documents: 'Dokumente',
      favorite: 'Favoriten'
    },
    emergencyInfo: 'Notfallinformationen',
    allergies: 'Allergien',
    healthConditions: 'Gesundheitszustand',
    medications: 'Medikamente',
    emergencyContacts: 'Notfallkontakte',
    addEmergencyContact: 'Notfallkontakt hinzufügen',
    personalInfo: 'Persönliche Informationen'
  },

  // Benachrichtigungsbereich
  notifications: {
    tabs: {
      incoming: 'Eingehend',
      reminders: 'Erinnerungen',
      tasks: 'Aufgaben'
    },
    markAllAsRead: 'Alle als gelesen markieren',
    new: 'Neu',
    goToGame: 'Zum Spiel gehen',
    noSearchResults: 'Keine Suchergebnisse gefunden',
    noNotifications: 'Noch keine Benachrichtigungen',
    noReminders: 'Noch keine Erinnerungen',
    clearSearch: 'Suche löschen',
    addReminder: 'Erinnerung hinzufügen',
    loading: 'Benachrichtigungen werden geladen...',
    reminder: {
      new: 'Neue Erinnerung',
      title: 'Titel',
      titlePlaceholder: 'Erinnerungstitel',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Beschreibung (optional)',
      date: 'Datum',
      time: 'Uhrzeit',
      category: 'Kategorie',
      priority: 'Priorität',
      repeat: 'Wiederholen',
      noRepeat: 'Keine Wiederholung'
    },
    categories: {
      personal: 'Persönlich',
      work: 'Arbeit',
      health: 'Gesundheit',
      finance: 'Finanzen',
      entertainment: 'Unterhaltung'
    },
    priorities: {
      low: 'Niedrig',
      medium: 'Mittel',
      high: 'Hoch'
    },
    repeat: {
      daily: '🔄 Täglich',
      weekly: '🔄 Wöchentlich',
      monthly: '🔄 Monatlich',
      yearly: '🔄 Jährlich'
    },
    filters: {
      all: 'Alle',
      connections: 'Verbindungen',
      messages: 'Nachrichten',
      verifications: 'Verifizierungen',
      security: 'Sicherheit',
      games: 'Spiele',
      system: 'System',
      active: 'Aktiv',
      completed: 'Abgeschlossen',
      highPriority: 'Hohe Priorität',
      mediumPriority: 'Mittlere Priorität',
      lowPriority: 'Niedrige Priorität'
    },
    time: {
      justNow: 'Gerade eben',
      minutesAgo: 'vor {minutes} Minuten',
      hoursAgo: 'vor {hours} Stunden',
      daysAgo: 'vor {days} Tagen',
      today: 'Heute {time}',
      tomorrow: 'Morgen {time}',
      futureDate: '{date} {time}',
      fullDate: '{day}/{month}/{year}'
    },
    errors: {
      loadFailed: 'Fehler beim Laden der Benachrichtigungsdaten:'
    },
    demo: {
      connectionRequest: 'Hat Ihnen eine Verbindungsanfrage gesendet',
      idappsVerification: 'IDapps-Verifizierung',
      qrVerified: 'Ihr QR-Code wurde erfolgreich verifiziert',
      securityCenter: 'Sicherheitscenter',
      newLogin: 'Ein neues Gerät hat sich bei Ihrem Konto angemeldet',
      system: 'System',
      appUpdated: 'IDapps-App wurde aktualisiert, entdecken Sie neue Funktionen',
      sentMessage: 'Hat Ihnen eine Nachricht gesendet: "Hallo, wie geht es Ihnen?"',
      gameHub: 'IDapps GameHub',
      newGame: 'Neues Spiel: Crypto Quest ist live! Turnier mit einem Preis von 50 IDCOIN gestartet.',
      connectionAccepted: 'Hat Ihre Verbindungsanfrage akzeptiert',
      reminders: {
        weeklyMeeting: 'Wöchentliches Meeting',
        teamMeeting: 'Team-Meeting - über Zoom',
        doctorAppointment: 'Arzttermin',
        dentalCheckup: 'Zahnkontrolle - Zahnklinik der Stadt',
        bills: 'Rechnungen',
        utilityBills: 'Strom- und Wasserrechnungszahlung',
        birthday: 'Geburtstag',
        mothersBirthday: 'Mamas Geburtstag - Geschenk besorgen',
        gameTournament: 'GameHub-Turnier',
        puzzleTournament: 'IDapps Blockchain-Puzzle-Turnier'
      }
    },
    tasks: {
      dailyTasks: 'Tägliche Aufgaben',
      wakeUp: 'Um 7 Uhr aufwachen',
      checkEmails: 'E-Mails überprüfen',
      reviewProject: 'Projektplan überprüfen',
      completeGameTasks: 'Tägliche Aufgaben in IDapps GameHub abschließen',
      workSchedule: 'Arbeitsplan',
      projectDevelopment: 'Projektentwicklung',
      meetings: 'Meetings',
      codeReviews: 'Code-Reviews',
      gameTournament: 'GameHub-Turnier',
      upcomingEvents: 'Kommende Veranstaltungen',
      blockchainMeetup: 'Blockchain-Meetup',
      web3Conference: 'Web3-Konferenz',
      onlineEvent: 'Online-Veranstaltung',
      idappsGameTournament: 'IDapps-Spieleturnier',
      metaverseEvent: 'Metaverse-Veranstaltung',
      goals: 'Ziele',
      dailyStepGoal: 'Tägliches Schrittziel',
      waterIntake: 'Wasseraufnahme (ml)',
      workTime: 'Arbeitszeit',
      idcoinGoal: 'IDCOIN-Ziel',
      hours: 'Stunden'
    }
  },

  // Blockchain und Wallet-Verbindungen
  blockchain: {
    connectWallet: 'Wallet verbinden',
    walletConnected: 'Wallet verbunden',
    walletAddress: 'Wallet-Adresse',
    arweaveSync: 'Arweave-Synchronisierung',
    backupToArweave: 'Backup auf Arweave',
    permanentStorage: 'Permanenter Speicher',
    walletTitle: 'Blockchain-Wallet',
    walletDescription: 'Sie können eine Blockchain-Wallet verbinden, um Ihre dezentralisierte Identität zu sichern.',
    wallet: 'Wallet'
  },

  // Bildschirmtitel
  screens: {
    dashboardTitle: 'Dashboard',
    qrScannerTitle: 'QR-Code-Scanner',
    gameHubTitle: 'Spielezentrum',
    messagingTitle: 'Nachrichten',
    notificationsTitle: 'Benachrichtigungen',
    forgotPasswordTitle: 'Passwort vergessen',
    chatsTab: 'Chats',
    groupsTab: 'Gruppen'
  },

  // Nachrichten-Bildschirm
  messaging: {
    searchChat: 'Chat durchsuchen...',
    noSearchResults: 'Keine Suchergebnisse gefunden',
    noResultsFor: 'Keine Ergebnisse für "{searchQuery}"',
    noGroupChats: 'Sie haben noch keine Gruppenchats erstellt.',
    createNewGroup: 'Neue Gruppe erstellen',
    encryptionDescription: 'Alle Ihre Nachrichten in IDapps sind Ende-zu-Ende verschlüsselt und können nur von Ihnen und der Person, mit der Sie chatten, gelesen werden.',
    selfDestructMessages: 'Selbstzerstörende Nachrichten',
    selfDestructDescription: 'Senden Sie selbstzerstörende Nachrichten für Ihre privaten Gespräche. Sie werden automatisch gelöscht, nachdem sie gelesen wurden.',
    activateFeature: 'Funktion aktivieren',
    aiAssistantPrivacy: 'KI-Assistent-Datenschutz',
    aiPrivacyDescription: 'Ihr Nachrichten-Assistent läuft vollständig auf Ihrem Gerät und Ihre Daten werden niemals an einen Server gesendet.',
    aiAssistantActive: 'KI-Assistent aktiv',
    aiResponseSuggestions: 'KI-Antwortvorschläge',
    writeMessage: 'Nachricht schreiben...',
    online: 'Online',
    lastSeen: 'Zuletzt gesehen: Heute um 15:42',
    greeting: 'Hey, wie geht es dir?',
    imGood: 'Mir geht es gut, und dir?',
    imGoodToo: 'Mir geht es auch gut, danke.',
    sentToYou: 'Ich habe es dir geschickt.',
    canYouSendFiles: 'Kannst du die Dateien senden?',
    agreed: 'Einverstanden.',
    projectCostQuestion: 'Hallo, können wir über die Kosten des Projekts sprechen?',
    whatDoYouThink: 'Sicher, was denkst du?',
    priceProposal: 'Ich denke, 500€ ist ein fairer Preis.',
    seeYou: 'Alles klar, bis dann.',
    meetingInvite: 'Meeting morgen um 15 Uhr, kannst du teilnehmen?',
    callMeWhenFree: 'Kannst du mich anrufen, wenn du frei bist?',
    aiSuggestion1: 'Ja, ich habe es fertig gestellt. Ich schicke es gleich.',
    aiSuggestion2: 'Ich arbeite daran, es wird morgen fertig sein.',
    aiSuggestion3: 'Ich habe es noch nicht fertig, ich werde es diese Woche abschließen.',
    aiSuggestion4: 'Sicher, ich rufe dich in 10 Minuten an.',
    aiSuggestion5: 'Ich bin gerade in einem Meeting, kann ich dich in 1 Stunde anrufen?',
    aiSuggestion6: 'Ich bin heute nicht verfügbar, kann ich dich morgen anrufen?'
  },

  // GameHub-Bereich
  gameHub: {
    loadingGames: 'Spiele werden geladen...',
    play: 'Spielen',
    join: 'Beitreten',
    progress: 'Fortschritt',
    level: 'Level {completed}/{total}',
    rewards: 'Belohnungen',
    points: 'Punkte',
    totalPoints: 'Gesamtpunkte',
    xpProgress: 'XP: {current}/{next}',
    featuredGame: 'Hervorgehobenes Spiel',
    categoriesTitle: 'Kategorien',
    allGames: 'Alle Spiele',
    seeAll: 'Alle anzeigen',
    dailyLogin: 'Tägliche Anmeldung',
    dayStreak: '{days} Tage Serie',
    dailyLoginInfo: 'Verdienen Sie IDCOIN durch tägliche Anmeldung. Bonusbelohnung, wenn Sie sich 7 Tage in Folge anmelden!',
    completed: '{completed}/{total} Abgeschlossen',
    playerCount: '{count} Spieler',
    coinReward: '{amount} IDCOIN Belohnung',
    participants: 'Teilnehmer: {count}',
    startingGame: 'Spiel {title} wird gestartet...',

    errors: {
      loadFailed: 'Fehler beim Laden der GameHub-Daten:'
    },

    tabs: {
      games: 'Spiele',
      daily: 'Täglich',
      leaderboard: 'Bestenliste',
      rewards: 'Belohnungen'
    },

    categories: {
      quiz: 'Quiz',
      puzzle: 'Puzzle',
      collection: 'Sammlung',
      simulation: 'Simulation',
      strategy: 'Strategie'
    },

    games: {
      cryptoQuest: {
        title: 'Crypto Quest',
        description: 'Machen Sie Fortschritte in der Krypto-Welt, testen Sie Ihr Wissen und verdienen Sie IDCOIN!'
      },
      blockchainPuzzle: {
        title: 'Blockchain-Puzzle',
        description: 'Lösen Sie Puzzles über Blockchain, vervollständigen Sie Smart Contracts!'
      },
      nftCollector: {
        title: 'NFT-Sammler',
        description: 'Sammeln Sie seltene NFTs, vervollständigen Sie Ihre Sammlung und verdienen Sie Belohnungen!'
      },
      defiTrader: {
        title: 'DeFi-Trader',
        description: 'Führen Sie DeFi-Transaktionen mit virtuellen Mitteln durch, entwickeln Sie die beste Strategie!'
      },
      daoManager: {
        title: 'DAO-Manager',
        description: 'Verwalten Sie Ihre DAO, bauen Sie die Gemeinschaft auf, treffen Sie die richtigen Entscheidungen!'
      }
    },

    dailyTasks: {
      title: 'Tägliche Aufgaben',
      completeAll: 'Schließen Sie alle Aufgaben ab, verdienen Sie einen Bonus!',
      completeAllBonus: 'Wenn Sie alle täglichen Aufgaben abschließen, erhalten Sie eine zusätzliche Bonusbelohnung von {coins} IDCOIN.',
      completeCryptoQuestLevels: 'Schließen Sie 3 Level in Crypto Quest ab',
      solveBlockchainPuzzle: 'Lösen Sie ein Puzzle in Blockchain-Puzzle',
      joinCryptoQuestTournament: 'Nehmen Sie am Crypto Quest-Turnier teil',
      collectDailyIdcoin: 'Sammeln Sie Ihre tägliche IDCOIN-Belohnung',
      inviteFriend: 'Laden Sie einen Freund zu GameHub ein'
    },

    tournament: {
      active: 'Aktives Turnier',
      activeTournaments: 'Aktive Turniere',
      ended: 'Beendet',
      daysHoursLeft: '{days} Tage {hours} Stunden verbleibend',
      hoursMinutesLeft: '{hours} Stunden {minutes} Minuten verbleibend',
      short: 'Turnier',
      joinAndWin: 'Nehmen Sie am Turnier teil und haben Sie die Chance, {coins} IDCOIN zu gewinnen!',
      gameTournament: '{game}-Turnier'
    },

    leaderboard: {
      yourRank: 'Ihre Platzierung',
      rankPosition: 'Platz {rank}',
      topPercentage: 'Sie sind unter den besten {percent}%!',
      weekly: 'Wöchentlich',
      allTime: 'Alle Zeiten',
      seeFullList: 'Vollständige Liste anzeigen',
      gameLeaderboards: 'Spiel-Bestenlisten',
      you: 'Sie'
    },

    rewards: {
      balance: 'Guthaben',
      transfer: 'Übertragen',
      transactions: 'Transaktionen',
      shop: 'Belohnungsshop',
      cost: '{amount} IDCOIN',
      daily: 'Täglich',
      completion: 'Abschluss',
      tournament: 'Turnier',

      items: {
        premium: {
          title: '1 Monat Premium',
          description: 'Werbefreie Erfahrung und zusätzliche Funktionen'
        },
        nft: {
          title: 'NFT-Item',
          description: 'Spezielle Avatare und digitale Gegenstände'
        },
        xpBoost: {
          title: 'XP-Boost',
          description: '2x Erfahrungspunkte für 3 Tage'
        },
        cryptoGift: {
          title: 'Krypto-Geschenk',
          description: 'Echte Kryptowährungsgeschenkkarte'
        }
      }
    },

    achievements: {
      title: 'Erfolge',
      completed: 'Abgeschlossen',
      seeAll: 'Alle Erfolge anzeigen',

      firstGame: 'Erstes Spiel',
      firstGameDesc: 'Spielen Sie Ihr erstes Spiel',
      firstTournament: 'Erstes Turnier', firstTournamentDesc: 'Nehmen Sie an einem Turnier teil',
      gameMaster: 'Spielmeister',
      gameMasterDesc: 'Spielen Sie 5 verschiedene Spiele',
      collector: 'Sammler',
      collectorDesc: 'Verdienen Sie 10 Erfolgsabzeichen'
    }
  },

  // IdentityCircle translations
  identityCircle: {
    title: 'IdentityCircle',
    subtitle: 'Ihre vertrauenswürdige soziale Ebene',
    visible: 'Sichtbar',
    hidden: 'Versteckt',
    hide: 'Verstecken',
    yourStory: 'Ihre Geschichte',
    invisibleMode: 'Unsichtbarer Modus Aktiv',
    invisibleDesc: 'Sie sind vollständig vor dem Kreis verborgen.',
    goVisible: 'Sichtbar werden',
    createContent: 'Inhalt erstellen',

    // Invisible mode enhancements
    invisible: {
      activated: 'Unsichtbarer Modus Aktiviert',
      redirecting: 'Weiterleitung zum Dashboard in {seconds} Sekunden...',
      reactivate: 'Unsichtbaren Modus Reaktivieren?',
      reactivateDesc: 'Sie waren zuvor im unsichtbaren Modus. Möchten Sie ihn reaktivieren?',
      yes: 'Ja, Unsichtbar werden',
      no: 'Sichtbar bleiben',
      goingInvisible: 'Unsichtbar werden...',
      countdown: 'Weiterleitung in {count}...'
    },

    tabs: {
      feed: 'Feed',
      connections: 'Verbindungen',
      projects: 'Projekte',
      knowledge: 'Wissen',
      identity: 'Identität'
    },

    create: {
      title: 'Inhalt erstellen',
      text: 'Textnotiz',
      voice: 'Sprachnotiz',
      voiceNote: 'Sprachnotiz erstellen',
      voiceDescription: 'Nehmen Sie Ihre Stimme auf und teilen Sie Ihre Gedanken',
      voiceTitle: 'Titel (Optional)',
      voiceTitlePlaceholder: 'Geben Sie Ihrer Sprachnotiz einen Titel...',
      newVoiceNote: 'Neue Sprachnotiz',
      voiceDesc: 'Aufnehmen und teilen Sie Ihre Stimme',
      startRecording: 'Aufnahme starten',
      stopRecording: 'Aufnahme stoppen',
      reRecord: 'Neu aufnehmen',
      recordingTime: 'Aufnahmezeit',
      recordingInProgress: 'Aufnahme läuft... Drücken Sie die Stopp-Taste zum Beenden',
      recordingCompleted: 'Aufnahme abgeschlossen! Bereit zum Teilen',
      recordingInstructions: 'Drücken Sie die Mikrofon-Taste, um die Aufnahme zu starten',
      shareVoice: 'Sprachnotiz teilen',
      thought: 'Gedanken teilen',
      thoughtDesc: 'Teilen Sie Ihre Ideen und Erfahrungen',
      stats: 'Statistiken teilen',
      statsDesc: 'Zeigen Sie Ihren Fortschritt',
      vault: 'Digitaler Tresor',
      vaultDesc: 'Gehen Sie zu Ihren persönlichen Notizen',
      image: 'Bild',
      video: 'Video'
    },

    stats: {
      title: 'Statistiken teilen',
      description: 'Teilen Sie Ihren Fortschritt mit Ihrem Kreis',
      selected: 'Ausgewählt',
      share: 'Teilen',
      addDescription: 'Beschreibung hinzufügen',
      descriptionPlaceholder: 'Optionale Beschreibung hinzufügen...',
      shareSuccess: 'Statistiken geteilt!'
    },

    thought: {
      shareSuccess: 'Gedanke geteilt!'
    },

    voice: {
      shareSuccess: 'Sprachnotiz geteilt!'
    },

    emptyState: {
      title: 'Ihr Kreis ist ruhig',
      description: 'Beleben Sie Ihren Kreis, indem Sie den ersten Inhalt teilen!',
      action: 'Erste Teilung machen'
    }
  }
};